import { apiUrl5, apiUrl1 } from "../configs/constant";

export const getDust20Balance = async (address, offset, limit = 12) => {
  const url = `${apiUrl5}/dust20/balance?address=${address}&limit=${limit}&offset=${offset}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getDust20BalanceTicker = async (address, output, tick, offset, limit, amount = 0) => {
  const url = `${apiUrl5}/dust20/balance/ticker?address=${address}&output=${output}&tick=${tick}&limit=${limit}&offset=${offset}&amount=${amount}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getDust20Indexer = async (tick, offset, limit, orderBy, orderDir) => {
  const url = `${apiUrl5}/dust20/indexer?tick=${tick}&limit=${limit}&offset=${offset}&orderBy=${orderBy}&orderDir=${orderDir}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getDust20IndexerTicker = async (tick, offset, limit = 12) => {
  const url = `${apiUrl5}/dust20/indexer/tick?tick=${tick}&limit=${limit}&offset=${offset}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getDust20CheckTicker = async (tick) => {
  const url = `${apiUrl5}/dust20/checkTicker?tick=${tick}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getDust20TickerDetail = async (tick) => {
  const url = `${apiUrl5}/dust20/detail/ticker?tick=${tick}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const saveDust20 = async (data) => {
  let response  = await fetch(`${apiUrl5}/dust20/payment/register`, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return {result : await response.json()};
}

export const getPaymentUtxosForDust20 = async (paymentAddress, inscriptionAddress, inscriptionAmount, fundingAddress, fundingAmount, paymentPubkey, feeRate, amount, provider) => {
  
  const url = `${apiUrl5}/getPaymentUtxosForDust20`;
  const data = {
    paymentAddress: paymentAddress,
    inscriptionAddress: inscriptionAddress,
    inscriptionAmount: inscriptionAmount,
    fundingAddress: fundingAddress,
    fundingAmount: fundingAmount,
    paymentPubkey: paymentPubkey,
    feeRate: feeRate,
    amount: parseInt(amount),
    provider: provider
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getDust20FilterUtxos = async (tempUtxos) => {
  
  const url = `${apiUrl5}/dust20/filterUtxos`;
  const data = {
    tempUtxos
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getDust20SafeTransferPsbt = async (utxos, address, amount, isAll, fundingAddress, fundingAmount, paymentAddress, paymentPubkey, feeRate, provider) => {
  
  const url = `${apiUrl5}/dust20/safeTransferPsbt`;
  const data = {
    utxos: utxos,
    address: address,
    amount: parseInt(amount * Math.pow(10, 8)),
    isAll: isAll,
    fundingAddress: fundingAddress,
    fundingAmount: fundingAmount,
    paymentAddress: paymentAddress,
    paymentPubkey: paymentPubkey,
    feeRate: feeRate,
    provider: provider
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getDust20BuyPsbt = async (data) => {
  
  const url = `${apiUrl1}/dust20/buyOrdinalsPsbt`;
  
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.text();
}

export const getDust20SplitMergePsbt = async (data) => {
  
  const url = `${apiUrl1}/dust20/splitMergePsbt`;
  
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.text();
}

export const getDust20UnlockPsbt = async (data) => {
  
  const url = `${apiUrl1}/dust20/unlockPsbt`;
  
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.text();
}

export const getTransactionData = async (txid) => {
  
  const url = `${apiUrl5}/transactionData?txid=${txid}`;
  
  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}
